import React, { useState, useEffect } from "react";
import { withCookies } from "react-cookie";

import HistoryDetail from "./showHistory";

const SingleHistory = ({ history, heading, config, board }) => {
  const [showHistoryDetail, setShowHistoryDetail] = useState(false);

  const handleShowHistoryDetail = () => {
    setShowHistoryDetail((pr) => !pr);
  };
  const handleHideHistoryDetail = () => {
    setShowHistoryDetail(false);
  };

  let [color, setColor] = useState(null);

  useEffect(() => {
    if (heading.columnNo > -1) {
      switch (parseInt(heading.columnNo)) {
        case 0: {
          setColor("sea-green");
          return "";
        }
        case 1: {
          setColor("light-red");
          return "";
        }
        case 2: {
          setColor("action-blue");
          return "";
        }
        case 3: {
          setColor("light-green");
          return "";
        }
        default: {
          setColor("primary");
          return "";
        }
      }
    }
  }, [heading]);
  return (
    <div className={`d-flex mt-2 flex-column`} style={{ padding: "12px" }}>
      <h3
        className="d-flex  align-items-top cursor-pointer"
        onClick={handleShowHistoryDetail}
      >
        <div
          style={{
            width: "35px",
            height: "35px",
            marginRight: "10px",
          }}
          className={`d-flex align-items-center justify-content-center bg-${color} rounded-circle text-white font-weight-bold`}
        >
          {heading?.columnNo + 1}
        </div>
        <div>
          <div style={{ fontSize: "16px", fontWeight: "700" }}></div>
          <small className="p-2 text-light-black" style={{ fontSize: "16px" }}>
            {history.title}
          </small>
        </div>
      </h3>
      <HistoryDetail
        handleClose={handleHideHistoryDetail}
        show={showHistoryDetail}
        color={color}
        history={history}
        columnName={heading?.columnName}
        columnNo={heading?.columnNo}
        config={config}
        board={board}
      />
    </div>
  );
};

export default withCookies(SingleHistory);
